var Backbone, SupportSelectDifferentOrderMenuTemplate, SupportV1OrderListView, SupportV1SelectDifferentOrderMenuView, SupportbasePopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportbasePopupView = require('../base_popup_view');

SupportV1OrderListView = require('./v1_order_list_view');

SupportSelectDifferentOrderMenuTemplate = require('../../../select_different_order_menu.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportV1SelectDifferentOrderMenuView = (function(superClass) {
  extend(SupportV1SelectDifferentOrderMenuView, superClass);

  function SupportV1SelectDifferentOrderMenuView() {
    return SupportV1SelectDifferentOrderMenuView.__super__.constructor.apply(this, arguments);
  }

  SupportV1SelectDifferentOrderMenuView.prototype.className = 'row';

  SupportV1SelectDifferentOrderMenuView.prototype.initialize = function() {
    var orderListView;
    this.template = SupportSelectDifferentOrderMenuTemplate;
    orderListView = new SupportV1OrderListView({
      currentOrdersFilter: Groupon.Support.currentOrdersFilter
    });
    return this.baseView = new SupportbasePopupView({
      popupView: orderListView
    });
  };

  SupportV1SelectDifferentOrderMenuView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, {
      faqInsteadHelpWizard: window.faqInsteadHelpWizard
    }, this.I18nScope));
  };

  SupportV1SelectDifferentOrderMenuView.prototype.actionHandler = function() {
    return this.baseView.render();
  };

  SupportV1SelectDifferentOrderMenuView.prototype.events = {
    "click #chooseOrder": "actionHandler"
  };

  return SupportV1SelectDifferentOrderMenuView;

})(Backbone.View);

module.exports = SupportV1SelectDifferentOrderMenuView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC92MV9zZWxlY3RfZGlmZmVyZW50X29yZGVyX21lbnVfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3YxX3NlbGVjdF9kaWZmZXJlbnRfb3JkZXJfbWVudV92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNJQUFBO0VBQUE7OztBQUFBLG9CQUFBLEdBQXVCLE9BQUEsQ0FBUSxvQkFBUjs7QUFDdkIsc0JBQUEsR0FBeUIsT0FBQSxDQUFRLHNCQUFSOztBQUN6Qix1Q0FBQSxHQUEwQyxPQUFBLENBQVEsb0RBQVI7O0FBQzFDLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7O2tEQUNKLFNBQUEsR0FBVzs7a0RBRVgsVUFBQSxHQUFZLFNBQUE7QUFDVixRQUFBO0lBQUEsSUFBQyxDQUFBLFFBQUQsR0FBWTtJQUNaLGFBQUEsR0FBZ0IsSUFBSSxzQkFBSixDQUEyQjtNQUN6QyxtQkFBQSxFQUFxQixPQUFPLENBQUMsT0FBTyxDQUFDLG1CQURJO0tBQTNCO1dBR2hCLElBQUMsQ0FBQSxRQUFELEdBQVksSUFBSSxvQkFBSixDQUF5QjtNQUNuQyxTQUFBLEVBQVksYUFEdUI7S0FBekI7RUFMRjs7a0RBU1osTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0I7TUFBQyxvQkFBQSxFQUFzQixNQUFNLENBQUMsb0JBQTlCO0tBQWxCLEVBQXVFLElBQUMsQ0FBQSxTQUF4RSxDQUFaO0VBRE07O2tEQUdSLGFBQUEsR0FBZSxTQUFBO1dBQ2IsSUFBQyxDQUFBLFFBQVEsQ0FBQyxNQUFWLENBQUE7RUFEYTs7a0RBR2YsTUFBQSxHQUNFO0lBQUEsb0JBQUEsRUFBd0IsZUFBeEI7Ozs7O0dBbkJnRCxRQUFRLENBQUM7O0FBcUI3RCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
